<div class="screen-title">Add Job</div>

<job-edit-form [model]="model | async" [users]="users | async | active" (onSave)="saveJob($event)" (onCancel)="cancel()" showCancel="true" [view]="view"></job-edit-form>
